import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-single-line-address-autosuggest]";
const PLUGIN_NAME = "SingleLineAddressAutoSuggest";
const INPUT_SELECTOR = "[data-suburb-validation]";
const POSTCODE_ELEMENT_SELECTOR = "[data-suburb-postcode-autosuggest-postcode]";
const POSTCODE_INPUT_ELEMENT_SELECTOR = ".postal_code";
class SingleLineAddressAutoSuggest {
  constructor(element, options) {
    this.$element = $(element);
    this.$input = this.$element.find(INPUT_SELECTOR);
    this.$postcode = this.$element.find(POSTCODE_ELEMENT_SELECTOR);
    this.$postcodeInput = this.$postcode.find(POSTCODE_INPUT_ELEMENT_SELECTOR);

    /*if (this.$input.val().length > 0) {
            this.validate();
        }
        this.watch();*/
  }

  postcodeIsValid(postcode) {
    var pcode = parseInt(postcode);
    if (isNaN(pcode)) {
      return false;
    }
    return (
      (pcode >= 1000 && pcode <= 1999) ||
      (pcode >= 2000 && pcode <= 2599) ||
      (pcode >= 2619 && pcode <= 2899) ||
      (pcode >= 2921 && pcode <= 2999) ||
      (pcode >= 200 && pcode <= 299) ||
      (pcode >= 2600 && pcode <= 2618) ||
      (pcode >= 2900 && pcode <= 2920) ||
      (pcode >= 3000 && pcode <= 3999) ||
      (pcode >= 8000 && pcode <= 8999) ||
      (pcode >= 4000 && pcode <= 4999) ||
      (pcode >= 9000 && pcode <= 9999) ||
      (pcode >= 5000 && pcode <= 5999) ||
      (pcode >= 6000 && pcode <= 6799) ||
      (pcode >= 6800 && pcode <= 6999) ||
      (pcode >= 7000 && pcode <= 7999) ||
      (pcode >= 800 && pcode <= 999)
    );
  }

  validate() {
    if (
      this.$postcodeInput.val().length > 0 &&
      this.postcodeIsValid(this.$postcodeInput.val())
    ) {
      this.$postcode.hide();
      return true;
    } else {
      this.$postcode.show();
      return false;
    }
  }

  watch() {
    var mod = this;

    this.$input.on("change", function() {
      mod.validate();
    });
  }
}

SingleLineAddressAutoSuggest.DEFAULTS = {};
plugin(PLUGIN_NAME, SingleLineAddressAutoSuggest);

$(document).ready(() => {
  $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/single-line-address-autosuggest.js